import React from 'react';
import { Button } from '@mui/material';
import Icon from 'icons/Icon';

type Props = {
  label?: string;
  value: string;
  height?: number;
  width?: number;
  onChange: (value: string) => void;
};
const acceptedFileTypes = 'image/x-png,image/jpeg,image/png,image/jpg';
const ImageUpload = ({ label, height, width, value, onChange }: Props) => {
  const uploadImage = (e: React.SyntheticEvent<unknown, Event>): void => {
    const reader = new FileReader();
    const { target } = e;
    if (
      target instanceof HTMLInputElement &&
      target.files &&
      target.files.length
    ) {
      const file = target.files[0];

      reader.addEventListener(
        'load',
        () => {
          // convert image file to base64 string
          const src = reader.result;

          if (typeof src === 'string') {
            if (!isBase64Image(src)) {
              throw Error('Not a valid image');
            }
            onChange(src);
          }
        },
        false,
      );
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Button style={{ backgroundColor: 'transparent', color: '#222' }}>
        <label htmlFor="file-input">
          <Icon
            iconName="edit"
            iconType="light"
            data-tip={`Change Image for ${label}`}
          />
          <input
            id="file-input"
            type="file"
            name="name"
            style={{ display: 'none' }}
            accept={acceptedFileTypes}
            onChange={uploadImage}
          />
        </label>
      </Button>
      <img
        src={value}
        style={{
          maxHeight: height ? height - 64 : 120,
          maxWidth: width ? width - 64 : 120,
        }}
        alt=""
      />
    </>
  );
};

function isBase64(data: string) {
  const regexBase64 =
    /^(?:[A-Z0-9+/]{4})*(?:[A-Z0-9+/]{2}==|[A-Z0-9+/]{3}=|[A-Z0-9+/]{4})$/i;
  return regexBase64.test(data);
}

export function isBase64Image(data: string) {
  const isImageString =
    data.includes('data:image/jpeg') ||
    data.includes('data:image/jpg') ||
    data.includes('data:image/png') ||
    data.includes('data:image/x-png');
  const index = data.indexOf('base64');
  const base64data = data.substring(index + 7);
  return data && isImageString && isBase64(base64data);
}

export default ImageUpload;
